import { render, staticRenderFns } from "./MailHistoryForm.vue?vue&type=template&id=41df378a&"
import script from "./MailHistoryForm.vue?vue&type=script&lang=js&"
export * from "./MailHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./MailHistoryForm.vue?vue&type=style&index=0&id=41df378a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports